import WHITELIST_PROVIDERS from 'app/common/data/providers';
import { useMyOrganization } from 'app/pages/app/AppDataProvider/hooks/useMyOrganization';

export const useHasAssignConversationFeature = (): boolean => {
    const org = useMyOrganization();
    const providerIsWhitelisted = WHITELIST_PROVIDERS.includes(org.provider);

    return providerIsWhitelisted;
};
